var map = {
	"./Intro.json": [
		"X9ud",
		1118
	],
	"./MyExercise.json": [
		"hkr3",
		1119
	],
	"./MyHealthyBody.json": [
		"g3gU",
		1120
	],
	"./MyHealthyMind.json": [
		"0trE",
		1121
	],
	"./MyNutrition.json": [
		"aDY7",
		1122
	],
	"./MySleep.json": [
		"8ru+",
		1123
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "PY5u";
module.exports = webpackAsyncContext;